
import Vue from 'vue'
import setProperties from './plugins/vueProperties'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import firebaseConfig from './configs/firebase-config.json'
import { firebase } from '@firebase/app'
import '@firebase/auth'
import '@firebase/firestore'
import Gravatar from 'vue-gravatar'
import VueNativeNotification from 'vue-native-notification'
import Clipboard from 'v-clipboard'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
import browserDetect from "vue-browser-detect-plugin"
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import VueMask from 'v-mask'
import VJsoneditor from 'v-jsoneditor'
import {baseUrl, baseApiUrl, tenantId} from './plugins/tenant'
import api from './plugins/axios'

/* Vue Use and Config */
Vue.config.productionTip = false
Vue.use(VueNativeNotification, {
  requestOnNotify: true
})
Vue.component('v-gravatar', Gravatar)
Vue.use(Clipboard)
Vue.use(VueToast, {
  position: 'top',
  duration: 5000,
  dismissible: true,
  pauseOnHover: true
})
Vue.use(browserDetect)
Vue.use(PerfectScrollbar)
Vue.use(VueMask)
Vue.use(VJsoneditor)

/* Vue Filters */
Vue.filter('minutes', (value) => {
  if (!value) return null
  return value.substr(3)
})

// firebase.initializeApp(firebaseConfig)
// Vue.prototype.$appConfig = firebaseConfig
// Vue.prototype.$auth = firebase.auth
// Vue.prototype.$db = firebase.firestore

/* Vue Properties */
setProperties(Vue)

new Promise((resolve, reject) => {
  if (tenantId == 'yama') {
    resolve(firebaseConfig)
  } else {
    api.get(`${baseApiUrl}/master/tenants/${tenantId}/appConfig`)
    .then(async response => {
      resolve(response.data.data)
    })
    .catch(e => reject(e) )
  }
}).then(async (appConfig)=> {

    // Initialize Firebase
    firebase.initializeApp(appConfig)
    Vue.prototype.$appConfig = appConfig
    Vue.prototype.$auth = firebase.auth
    Vue.prototype.$db = firebase.firestore
    Vue.prototype.$timestamp = firebase.firestore.Timestamp

    /**
     * Chamada de integrações
     */

    /**
     * Definição das rotas de cada integração cadastrada na collection integrations
     */
    const integrations = new Promise((resolve, reject) => {
      firebase.firestore().collection('integrations')
      .where('lifeControl.deletedAt', '==', null)
      .where('active', '==', true)
      .orderBy('menuOrder')
      .get()
      .then(function (querySnapshot) {
        let integrations = []
        for (const doc of querySnapshot.docs) {
          const integration = { id: doc.id, ...doc.data() }
          if (integration.active)
          integrations.push(integration)
        }
          resolve(integrations)
      })
      .catch(e => reject(e))
    });

    const userRules = new Promise((resolve, reject) => {
      firebase.firestore().collection('userRules')
      .where('lifeControl.deletedAt', '==', null)
      .where('active', '==', true)
      .get()
      .then(function (querySnapshot) {
        let userRules = []
        for (const doc of querySnapshot.docs) {
          const userRule = { id: doc.id, ...doc.data() }
          if (userRule.active)
          userRules.push(userRule)
        }
        resolve(userRules)
      })
      .catch(e => reject(e))
    });


    Promise.all([integrations, userRules]).then((values) => {
      Vue.prototype.$integrations = values[0];
      Vue.prototype.$userRules = values[1];
    
      new Vue({
        router: router(values[0], values[1]),
        store,
        vuetify,
        render: h => h(App)
      }).$mount('#app')
    })
    .catch((err) => console.error("Error getting integrations and userRules: ", err))

})

